module.exports = __webpack_public_path__ + "img/sfzfm.e24add84.png";